module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "input",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event)
      }
    }
  }), _vm._v(" "), _c('md-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('md-menu', {
    ref: "menu",
    staticClass: "md-autocomplete-menu",
    attrs: {
      "md-size": "5",
      "md-direction": "top right"
    }
  }, [_c('span', {
    attrs: {
      "md-menu-trigger": ""
    }
  }), _vm._v(" "), _c('md-menu-content', {
    staticClass: "content-autocomplete"
  }, _vm._l((_vm.arrayFilter), function(item) {
    return _c('md-menu-item', {
      key: item['.key'],
      nativeOn: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": item.photoURL
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.displayName))])], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a30deb8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autocomplete.vue
// module id = 382
// module chunks = 1